import Fuse from "fuse.js";
import type { POI } from "../components/MapCanvas";

/**
 * Creates a Fuse.js search index for POIs
 * Configured for fuzzy matching on name, description, category, and tags
 */
export function createPOISearchIndex(pois: POI[]): Fuse<POI> {
  // Transform POIs to include joined tags for searchability
  const searchablePois = pois.map((poi) => ({
    ...poi,
    tagsJoined: poi.tags.map((t) => t.name).join(" "),
  }));

  return new Fuse(searchablePois, {
    keys: [
      { name: "name", weight: 1.0 },
      { name: "category.name", weight: 0.8 },
      { name: "tagsJoined", weight: 0.8 },
      { name: "description", weight: 0.7 },
    ],
    threshold: 0.3,
    ignoreLocation: true,
    minMatchCharLength: 2,
  });
}

/**
 * Searches POIs using the Fuse index
 * Returns matching POIs sorted by relevance
 */
export function searchPOIs(fuse: Fuse<POI>, query: string): POI[] {
  const results = fuse.search(query);
  return results.map((r) => r.item);
}
